import { render, staticRenderFns } from "./AuthLeftPanel.vue?vue&type=template&id=36dbf576&scoped=true"
import script from "./AuthLeftPanel.vue?vue&type=script&lang=js"
export * from "./AuthLeftPanel.vue?vue&type=script&lang=js"
import style0 from "./AuthLeftPanel.vue?vue&type=style&index=0&id=36dbf576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dbf576",
  null
  
)

export default component.exports